import React from 'react';
import type { CapexCaptureWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<CapexCaptureWidgetConfig>;
  onChange: (config: CapexCaptureWidgetConfig) => void;
}

const CapexCaptureWidgetBuilder: React.FC<Props> = () => (
  <div className="space-y-4">
    <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
      <strong>{definition.meta.label}</strong>
      <p className="mt-1">{definition.meta.description}</p>
    </div>
    <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
      <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
      <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
        <li>The asset&apos;s revenue (FMP income statement), left axis</li>
        <li>Summed hyperscaler capex MSFT + GOOGL + AMZN + META (FMP cash-flow), left axis</li>
        <li>% Capture = revenue ÷ total capex, right axis</li>
        <li>Aligned by calendar year (the hyperscalers have different fiscal year-ends)</li>
      </ul>
    </div>
  </div>
);

export default CapexCaptureWidgetBuilder;
